<template>
    <div :class="filtered ? 'container-fluid product-wrapper sidebaron' : 'container-fluid product-wrapper'">
        <div class="product-grid">
            <div class="feature-products">
                <div class="row m-b-10">
                    <div class="col-md-3 col-sm-2 products-total">
                        <div class="square-product-setting d-inline-block"><a class="icon-grid grid-layout-view"
                                @click="gridView()">
                                <vue-feather type="grid"></vue-feather>
                            </a></div>
                        <div class="square-product-setting d-inline-block"><a class="icon-grid m-0 list-layout-view"
                                @click="listView()">
                                <vue-feather type="list"></vue-feather>
                            </a></div>
                        <div class="d-none-productlist filter-toggle" @click="collapseFilter()">
                            <h4 class="mb-0">Filters<span class="ms-2">
                                    <vue-feather class="toggle-data" type="chevron-down"></vue-feather>
                                </span></h4>
                        </div>
                        <div class="grid-options d-inline-block">
                            <ul>
                                <li @click="grid2()"><a class="product-2-layout-view" data-original-title="" title=""><span
                                            class="line-grid line-grid-1 bg-primary"></span><span
                                            class="line-grid line-grid-2 bg-primary"></span></a>
                                </li>
                                <li @click="grid3()"><a class="product-3-layout-view" data-original-title="" title=""><span
                                            class="line-grid line-grid-3 bg-primary"></span><span
                                            class="line-grid line-grid-4 bg-primary"></span><span
                                            class="line-grid line-grid-5 bg-primary"></span></a>
                                </li>
                                <li @click="grid4()"><a class="product-4-layout-view" data-original-title="" title=""><span
                                            class="line-grid line-grid-6 bg-primary"></span><span
                                            class="line-grid line-grid-7 bg-primary"></span><span
                                            class="line-grid line-grid-8 bg-primary"></span><span
                                            class="line-grid line-grid-9 bg-primary"></span></a>
                                </li>
                                <li @click="grid6()"><a class="product-6-layout-view" data-original-title="" title=""><span
                                            class="line-grid line-grid-10 bg-primary"></span><span
                                            class="line-grid line-grid-11 bg-primary"></span><span
                                            class="line-grid line-grid-12 bg-primary"></span><span
                                            class="line-grid line-grid-13 bg-primary"></span><span
                                            class="line-grid line-grid-14 bg-primary"></span><span
                                            class="line-grid line-grid-15 bg-primary"></span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <sortingPage />
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="pro-filter-sec">
                            <div class="product-sidebar" :class="filtered ? 'open' : ''">
                                <div class="filter-section">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="mb-0 f-w-600">Filters<span class="pull-right"><i
                                                        class="fa fa-chevron-down toggle-data"
                                                        @click="collapseFilter()"></i></span></h4>
                                        </div>
                                        <filterPage />
                                    </div>
                                </div>
                            </div>
                            <div class="product-search">
                                <form>
                                    <div class="form-group m-0">
                                        <input class="form-control" type="search" placeholder="Search@"
                                            data-original-title="" title=""><i class="fa fa-search"></i>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <productView />
        </div>
    </div>
</template>
<script>
import filterPage from './filterPage.vue'
import productView from './productView.vue'
import sortingPage from './sortingPage.vue'
import productMixin from "@/mixins/productMixin"
export default {
    name: 'topPage',
    mixins: [productMixin],
    components: {
        filterPage, productView, sortingPage
    },
}
</script>